import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

export const useColumns = () => {
    const navigate = useNavigate();

    const truncateString = (str, maxLength = 50) => {
        if (str.length > maxLength) {
            return str.substring(0, maxLength) + '...';
        }
        return str;
    };

    const handleQuizClick = (id) =>{
        navigate(`/dashboard/quiz/${id}`);  
    }


    const columns = [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },

        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
            
        },

        {
            title: 'Tačni odgovori',
            dataIndex: 'correctAnswers',
            key: 'correctAnswers',
        },

        {
            title: 'Tekst',
            dataIndex: 'whyMe',
            key: 'whyMe',
            className: 'clickable-column',
            render: (text) => truncateString(text, 50),
            onCell: (record) => ({
                onClick: () => handleQuizClick(record.quizId), // Handle onClick at the cell level
            }),
        },

        {
            title: 'Vreme trajanja',
            dataIndex: 'quizTime',
            key: 'quizTime',
            render: (text) => text / 1000 +"s",
        },

        {
            title: 'Datum prijave',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => dayjs(text).format('D MMM YYYY'),
        },
    ];

    return columns
}
